import { captureAppError } from '@leagueplatform/observability';
import { EligibilityInfo, getAppInitDetails } from 'api/get-app-init-details';
import { SENTRY_CONSTANTS } from 'common/constants';

export interface UserEligibilityResult {
  eligible: boolean;
  details: EligibilityInfo | null;
  error?: boolean;
  errorName?: string;
  productSubType?: string;
  coverageExperience?: string;
  productSubTypes?: string[];
}

const getErrorName = (error: unknown): string => {
  if (error instanceof Error) {
    return error.name;
  }

  return 'UnknownError';
};

export const getUserEligibility = async (
  isAuthenticated: boolean,
): Promise<UserEligibilityResult> => {
  try {
    const appInitDetails = await getAppInitDetails();

    return {
      eligible: appInitDetails.eligibilityInfo.eligible,
      details: appInitDetails.eligibilityInfo,
      productSubType: appInitDetails.productSubType,
      coverageExperience: appInitDetails.coverageExperience,
      productSubTypes: appInitDetails.segmentation?.productSubTypes,
    };
  } catch (e: unknown) {
    const errorName = getErrorName(e);

    captureAppError(new Error('Failed to fetch user eligibility'), {
      context: {
        Context: {
          authenticated: isAuthenticated,
          errorName,
        },
      },
      ownershipTeam: SENTRY_CONSTANTS.OWNERSHIP_TEAM,
      tags: {
        authenticated: isAuthenticated,
      },
    });
    return {
      eligible: false,
      details: null,
      error: true,
      errorName,
    };
  }
};
